import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '^zoid-definitions/mockXprops';
import logger from '^utils/logger';
import gtmHelper from '^utils/gtmHelper';

import App from './App';

import '^scss-global';

logger.init();
gtmHelper.init();

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root not found');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
